import React from "react";

const Price = ({ scrollToConsult }) => {
  return (
    <section className="p-3 p-lg-0">
      <div className="container border border-1 border-dark rounded-4 mt-5 mb-5">
        <div className="row align-items-center">
          <div className="col-lg-5 p-5">
            <h2 className="fs-40">What’s It Cost?</h2>
            <p>
              We keep all our pricing as clear and transparent as possible with
              no hidden cost and our flexible payment plans make treatment
              affordable for all.
            </p>
            <p>0% Finance Available On Request</p>
            <div
              className="d-none d-md-block cursor-pointer"
              onClick={scrollToConsult}
            >
              <a className="btn-golden animate__animated animate__slideInRight cursor-pointer">
                BOOK A FREE CONSULTATION
              </a>
            </div>
          </div>
          <div className="col-lg-7 bg-theme rounded-4">
            <div className="row p-4 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">
                  10 teeth Composite Bonding
                </p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £3,500
                  </span>
                  <span className="fs-24">£3,200</span>
                </p>
              </div>
            </div>

            <div className="row p-4 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Smile Assessment </p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £75
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>

            <div className="row p-4 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Digital Smile Preview</p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £250
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>

            <div className="row p-4 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Electric Toothbrush </p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £60
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>

            <div className="row p-4 border-bottom">
              <div className="col-lg-7">
                <p className="fs-24 text-white fw-500">Teeth Whitening</p>
              </div>
              <div className="col-lg-5 text-end">
                <p className="fs-24 text-white">
                  <span className="fs-14 me-2">From</span>
                  <span className="fs-18 text-decoration-line-through me-2">
                    £295
                  </span>
                  <span className="fs-24">Free</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Price;
